import { SELF_USER_LOAD_SUCCESS, SELECT_ORGANIZATION, DESELECT_ORGANIZATION } from "../../actions/accounts/types";
import { shallowEqual, useSelector } from 'react-redux';

const initialState = {
    user: false
};

export const userReducer = (state=initialState, action) => {
    const {type, payload} = action;
    let user = state.user;
    let organization, index;
    switch(type){
        case SELF_USER_LOAD_SUCCESS: 
            return {
                ...state,
                user: payload
            };
        case SELECT_ORGANIZATION:
            organization = user?.organizations.find(item => item.id === payload.id);
            index = user?.organizations.indexOf(organization);
            organization.selected = true;
            user?.organizations.splice(index, 1, organization);
            return {
                ...state,
                user: user
            };
        case DESELECT_ORGANIZATION:
            organization = user?.organizations.find(item => item.id === payload.id);
            index = user?.organizations.indexOf(organization);
            organization.selected = false;
            user?.organizations.splice(index, 1, organization);
            return {
                ...state,
                user: user
            };
        default:
            return state;
    }
}

export const useSelfUser = () => useSelector((state) => state.user);

export const useSelectedOrganizations = () => useSelector((state) => state.user?.user?.organizations?.filter(item => item?.selected), shallowEqual)